import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSearchText = createSelector(
  [(store: RootState) => store.documentShow.searchText],
  (data) => data
);
